import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { updateDataLink } from '../../helpers/general';
import { IChangeHistoryDataItem, IChangeHistoryLayout } from '../../types/layout/change-history';
import useRest from '../useRest';

export const useChangeHistory = ({ actions, dataLink, primaryKey }: IChangeHistoryLayout) => {
    const [data, setData] = useState<IChangeHistoryDataItem[]>([]);
    const [loading, setLoading] = useState(false);

    const rest = useRest();

    const { objectId } = useParams();

    const getData = async () => {
        if (typeof dataLink === 'string') {
            setLoading(true);

            const result = await rest.fetch({
                objectName: updateDataLink(dataLink, objectId),
                method: 'post',
            });

            if (!result.isError && result.response?.data) {
                setData(result.response.data);
            }

            setLoading(false);
        }
    };

    const rowDelete = async (row: Record<string, any>) => {
        if (typeof actions?.delete === 'string' && typeof primaryKey === 'string') {
            const alertResult = await Swal.fire({
                title: 'Подтвердите действие',
                text: 'Вы действительно хотите удалить запись?',
                confirmButtonText: 'Да, удалить',
                cancelButtonText: 'Отмена',
                icon: 'question',
                showCancelButton: true,
            });

            if (alertResult.isConfirmed) {
                setLoading(true);

                await rest.fetch({
                    method: 'post',
                    objectName: updateDataLink(actions.delete, row[primaryKey]),
                });

                await getData();

                setLoading(false);
            }
        }
    };

    useEffect(() => {
        getData();
    }, [dataLink]);

    return {
        data,
        loading,
        getData,
        rowDelete,
    };
};
